import { FormUnit, type GetFormInput } from "@suse-o11y/signal/form";
import { z } from "zod";

import { isStringDirty } from "~/tools/is-string-dirty";

const schema = z.union([
	// treat the blank string as undefined
	z
		.string()
		.trim()
		.pipe(z.literal(""))
		.transform(() => undefined),

	// convert the non-empty string to a number
	z.coerce.number(),
]);

type FormState = FormUnit<string, ReadonlyArray<string>, undefined | number>;

type Input = GetFormInput<FormState>;

const INITIAL = "" satisfies Input;

function init(initial?: Input): FormState {
	return FormUnit(initial ?? INITIAL, {
		isInputDirty: isStringDirty,
		schema,
	});
}

const FormState = {
	initial: INITIAL,
	init,
} as const;

export { FormState };
